import { render, staticRenderFns } from "./ListMatchInternal.vue?vue&type=template&id=43552922&"
import script from "./ListMatchInternal.vue?vue&type=script&lang=js&"
export * from "./ListMatchInternal.vue?vue&type=script&lang=js&"
import style0 from "./ListMatchInternal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports